import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Building2, Briefcase, FileText } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { Button } from '../components/ui/Button';
export function Services() {
  const services = [{
    id: 'property-management',
    title: 'Property Management',
    icon: <Building2 size={40} data-id="element-446" />,
    desc: 'Maximizing asset value and operational performance for luxury villas, hotels, and hospitality businesses in Bali.',
    features: ['Property Operations', 'Revenue Optimization', 'Staff Management', 'Guest Experience', 'Monthly Reporting'],
    img: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    link: '/property-management'
  }, {
    id: 'business-finance',
    title: 'Accounting, Tax & Audit',
    icon: <Briefcase size={40} data-id="element-447" />,
    desc: 'Comprehensive financial services ensuring transparency, compliance, and strategic growth for your enterprise.',
    features: ['Bookkeeping & Financial Statements', 'Corporate & Individual Tax', 'Tax Planning & Coretax', 'Internal & External Audit', 'Financial Review'],
    img: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    link: '/business-finance-services'
  }, {
    id: 'legal-expat',
    title: 'Legal, Licensing & Expat Services',
    icon: <FileText size={40} data-id="element-448" />,
    desc: 'Expert navigation of Indonesian corporate law, business licensing, and immigration requirements.',
    features: ['PT PMA Establishment', 'Business Licenses (OSS, NIB)', 'Corporate Governance', 'Investor & Business Visas', 'KITAS & Work Permits'],
    img: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&auto=format&fit=crop&w=1212&q=80',
    link: '/legal-licensing-expat-services'
  }];
  return <div className="bg-navy-900 min-h-screen" data-id="element-449">
      <PageHeader title="Our Premium Services" subtitle="Integrated corporate solutions tailored for investors, property owners, and businesses establishing their presence in Indonesia." backgroundImage="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" data-id="element-450" />

      <section className="py-24" data-id="element-451">
        <div className="max-w-content mx-auto px-6 md:px-12 space-y-24" data-id="element-452">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className={`flex flex-col ${index % 2 !== 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`} data-id="element-453">
              <div className="w-full lg:w-1/2" data-id="element-454">
                <div className="relative h-[400px] rounded-card overflow-hidden shadow-card group" data-id="element-455">
                  <img src={service.img} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-456" />
                  <div className="absolute inset-0 bg-navy-900/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-457"></div>
                </div>
              </div>

              <div className="w-full lg:w-1/2 space-y-6" data-id="element-458">
                <div className="w-16 h-16 bg-navy-800 rounded-2xl flex items-center justify-center text-gold shadow-soft" data-id="element-459">
                  {service.icon}
                </div>
                <h2 className="font-display text-3xl md:text-4xl font-bold text-white" data-id="element-460">
                  {service.title}
                </h2>
                <p className="font-body text-gray-400 text-lg leading-relaxed" data-id="element-461">
                  {service.desc}
                </p>

                <ul className="space-y-3 py-4" data-id="element-462">
                  {service.features.map((feature, i) => <li key={i} className="flex items-center gap-3 text-gray-300 font-body" data-id="element-463">
                      <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-464"></div>
                      {feature}
                    </li>)}
                </ul>

                <Button to={service.link} variant="outline" icon={<ArrowRight size={18} data-id="element-466" />} data-id="element-465">
                  Explore Details
                </Button>
              </div>
            </motion.div>)}
        </div>
      </section>

      <section className="py-24 bg-navy-800 border-t border-navy-700 text-center" data-id="element-467">
        <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-468">
          <h2 className="font-display text-4xl font-bold text-white mb-6" data-id="element-469">
            Need a Custom Solution?
          </h2>
          <p className="font-body text-gray-400 text-lg mb-10" data-id="element-470">
            Our consultants are ready to tailor a strategy that aligns perfectly
            with your business objectives in Bali.
          </p>
          <Button to="/contact" data-id="element-471">Book a Free Consultation</Button>
        </div>
      </section>
    </div>;
}